import React from "react";

const ChatListViewHeader = () => <h1 className="header-title">{i18n.t("rtm.header.your_questions")}</h1>;

export default ChatListViewHeader;
